import React from 'react';
import { useMediaQuery } from "react-responsive";

const DashboardSkeleton = () => {
    const isMobile = useMediaQuery({ maxWidth: 575.98 });
    const isTablet = useMediaQuery({ minWidth: 576, maxWidth: 991.98 });

    return (
        <>
            <div className="skeleton skeleton-card mb-4" style={{ height: isMobile ? "80px" : "100px" }} />
            <div className="stats-grid mb-4" style={isMobile ? { gridTemplateColumns: 'repeat(2, 1fr)' } : {}}>
                {[1, 2, 3, 4].slice(0, isMobile ? 2 : 4).map(i => (
                    <div className="skeleton skeleton-card" key={i} style={{ height: isMobile ? "100px" : "120px" }} />
                ))}
            </div>
            <div className="skeleton skeleton-card mb-4" style={{ height: isMobile ? "200px" : "300px" }} />
            <div className="row">
                <div className={isMobile ? "col-12 mb-4" : isTablet ? "col-md-6 mb-4" : "col-xl-8"}>
                    <div className="skeleton skeleton-card" style={{ height: isMobile ? "300px" : "400px" }} />
                </div>
                <div className={isMobile ? "col-12" : isTablet ? "col-md-6" : "col-xl-4"}>
                    <div className="skeleton skeleton-card" style={{ height: isMobile ? "250px" : "400px" }} />
                </div>
            </div>
        </>
    );
};

export default DashboardSkeleton; 